import React from 'react';
import tokens from '../design/tokens';
import { tileForGrade } from '../services/monitoringApi';

const C = tokens.color;
const R = tokens.radius;
const G = tokens.grade;
const TILE_LABEL = { good: 'Good', watch: 'Watch', attention: 'Attention', critical: 'Critical' };

/**
 * Grade chip: "D · Attention" in the grade's own colours — the same letter and
 * word as the Fleet cards, MotorDetail and the PDF. '-' is the no-data value
 * and renders grey with `noData` ("Offline" for a silent sensor, "No data"
 * for a fleet with nothing reporting). Never a status colour for no data.
 */
export default function GradeChip({ grade, noData = 'No data', title }) {
  const chip = { display: 'inline-flex', alignItems: 'center', gap: 6, padding: '3px 10px', borderRadius: R.full, fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap' };
  const letter = { fontFamily: tokens.font.display, fontWeight: 800 };
  if (grade === '-') {
    return <span title={title} style={{ ...chip, background: C.surfaceAlt, color: C.textMuted }}><span style={letter}>—</span> · {noData}</span>;
  }
  const g = G[grade];
  if (!g) return null;
  return (
    <span title={title} style={{ ...chip, background: g.bg, color: g.fg }}>
      <span style={letter}>{grade}</span> · {TILE_LABEL[tileForGrade(grade)]}
    </span>
  );
}
